module.exports = __webpack_public_path__ + "static/media/slider-bottom.1b6cf28c.JPG";